/**
 * Isolated styles for the staff profile Facility History (PLA) tab.
 */
export default (theme) => ({
  plaHistoryRoot: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: [theme.spacing(0.5), 0, theme.spacing(1)].join(' '),
  },
  /** Matches staff profile Facilities section (staff-profile.style facilities*). */
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2),
  },
  sectionHeading: {
    ...theme.typography.t25,
    ...theme.typography.bold,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary?.jetBlack || theme.palette.text.primary,
  },
  sectionExplainer: {
    ...theme.typography.t16,
    marginBottom: 0,
    color:
      theme.palette.text?.primary ||
      theme.palette.primary?.jetBlack ||
      'var(--Navy---navy-main, #061E44)',
  },
  plaHistoryGridWrap: {
    width: '100%',
    minWidth: 0,
    /**
     * @orijinworks/frontend-commons DataGrid uses height:100% on .tabl-container, table, and
     * block-level tbody. Without a fixed-height ancestor (staff profile tab), that collapses
     * and the body area can show no rows. Force auto height so rows flow by content.
     */
    '& .tabl-container': {
      height: 'auto !important',
      minHeight: 360,
    },
    '& .main-table': {
      height: 'auto !important',
    },
    '& .main-table tbody': {
      height: 'auto !important',
      maxHeight: 'none !important',
      overflow: 'visible !important',
    },
    '& .main-table tbody tr': {
      backgroundColor: 'transparent !important',
    },
  },
  plaHistoryEmpty: {
    color: 'var(--Greyscale---grey-110, #333333)',
    padding: theme.spacing(2, 0),
  },
  plaHistoryError: {
    color: theme.palette.error?.main || '#c62828',
    padding: theme.spacing(2, 0),
  },
});
